<template>
  <BuildingSectionCard
    title="Renter requirements"
    tone="secondary"
    :hint="unitDefaultHint"
    :form="RenterRequirementsForm"
    :has-info="Boolean(requirements)"
    :placeholder="{
      title: 'No default requirements yet',
      subtitle: 'New units start without screening criteria until you set a default.',
      buttonText: 'Add requirements',
    }"
  >
    <template v-if="requirements" #subtitle>
      <DefaultDriftLine
        :building-id="building.id"
        :differing-ids="building.defaultsDrift?.renterRequirements"
        :units="units"
      />
    </template>

    <PropertyDetailsCardRows v-if="requirements">
      <PropertyDetailsCardInfoItem
        v-if="requirements.minimumCreditScore"
        label="Credit score"
        icon="speedometer-03"
        :value="requirements.minimumCreditScore"
      />
      <PropertyDetailsCardInfoItem v-if="requirements.minimumIncome" label="Income" icon="wallet-02" :value="income" />
      <PropertyDetailsCardInfoItem
        v-if="requirements.screeningSensitivity"
        label="Screening"
        icon="sliders-04"
        :value="requirements.screeningSensitivity"
      />
      <PropertyDetailsCardInfoItem
        v-if="requirements.acceptsCosigners !== null"
        label="Co-signers"
        icon="users-01"
        :value="requirements.acceptsCosigners ? 'Accepted' : 'Not accepted'"
      />
    </PropertyDetailsCardRows>
  </BuildingSectionCard>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { BuildingDto, PropertyListItemDto, RenterRequirementsForm, rentMultipleLabel } from '@tallo/investor/property';
import { PropertyDetailsCardInfoItem, PropertyDetailsCardRows } from '@tallo/property';

import BuildingSectionCard from '../../../components/building-section-card.vue';
import DefaultDriftLine from '../default-drift-line.vue';
import { unitDefaultHint } from './unit-default.const';

/** The screening a new unit starts with, and how many units still keep it */
const props = defineProps<{ building: BuildingDto; units: PropertyListItemDto[] }>();

const requirements = computed(() => props.building.renterRequirements);
const income = computed(() => requirements.value?.minimumIncome && rentMultipleLabel(requirements.value.minimumIncome));
</script>
